import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";
import { useUserStore } from "~/stores/userstore";
import { useCompaniesStore } from "~/stores/companiesstore";

export default defineNuxtRouteMiddleware((routeLocationTo, _unused_from) => {
  console.debug("companyIsVisible middleware");
  const userStore = useUserStore();
  const companiesStore = useCompaniesStore();
  const toastStore = useToastStore();

  // user is admin - allow all
  if (userStore.isStoreAdmin) {
    return;
  }

  // get companyId from route params
  const companyId = (() => {
    const p = routeLocationTo.params.companyid;
    return Array.isArray(p) ? (p[0] ?? "") : (p ?? "");
  })();

  const hubName = (() => {
    const p = routeLocationTo.params.hub;
    return Array.isArray(p) ? (p[0] ?? "") : (p ?? "");
  })();

  // get company from store
  const company = companiesStore.getCompanyById(companyId);
  if (!company) {
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Company not found`,
      body: `The requested company could not be found.`,
      appendToast: false,
      position: "top-center",
      variant: "info",
      solid: true,
    } as ToastItem);
    return navigateTo("/");
  }

  // is user member of company
  const userIsMember = userStore.authUser?.companyId === companyId;
  const userIsCompanyAdmin = userStore.isCompanyAdmin;
  if (userIsMember && userIsCompanyAdmin) {
    console.debug("user is company admin - allowed");
    return;
  }
  if (!companiesStore.companyIsActiveHub(hubName, companyId)) {
    // TODO security - report not found instead?
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Company not active`,
      body: `The requested company not active in the ${hubName} store.`,
      appendToast: false,
      position: "top-center",
      variant: "info",
      solid: true,
    } as ToastItem);
    return navigateTo("/");
  }
});
